import { useFamilyContext } from '../contexts/FamilyContext';

/**
 * Custom hook for managing Ideas & Opportunities
 * Provides access to ideas data and CRUD operations
 */
export const useRecsIdeas = () => {
  const { 
    recsIdeas, 
    addIdea, 
    editIdea, 
    deleteIdea, 
    updateIdeaStatus,
    loading,
    error
  } = useFamilyContext();

  // Transform the data to match expected interface
  const ideas = recsIdeas || [];

  // Provide consistent API for ideas operations
  const createIdea = async (ideaData) => {
    return await addIdea(ideaData);
  };

  const updateIdea = async (ideaId, updates) => {
    return await editIdea(ideaId, updates);
  };

  const removeIdea = async (ideaId) => {
    return await deleteIdea(ideaId);
  };

  const updateStatus = async (ideaId, kidId, status) => {
    return await updateIdeaStatus(ideaId, kidId, status);
  };

  // Helper functions for idea processing
  const getIdeaById = (ideaId) => {
    return ideas.find(idea => idea.id === ideaId);
  };

  const getIdeasByCategory = (category) => {
    return ideas.filter(idea => idea.category === category);
  };

  const getIdeasForKid = (kidId) => {
    return ideas.filter(idea => 
      idea.targetKids && Array.isArray(idea.targetKids) && 
      idea.targetKids.includes(kidId)
    );
  };

  const getIdeaStats = () => {
    const total = ideas.length;
    const byCategory = ideas.reduce((acc, idea) => {
      acc[idea.category] = (acc[idea.category] || 0) + 1;
      return acc;
    }, {});
    
    const withResponses = ideas.filter(idea => 
      idea.kidResponses && Object.keys(idea.kidResponses).length > 0
    ).length;

    return {
      total,
      byCategory,
      withResponses,
      pending: total - withResponses
    };
  };

  return {
    // Data
    ideas,
    loading,
    error,
    
    // CRUD operations
    addIdea: createIdea,
    updateIdea,
    deleteIdea: removeIdea,
    updateIdeaStatus: updateStatus,
    
    // Helper functions
    getIdeaById,
    getIdeasByCategory, 
    getIdeasForKid,
    getIdeaStats
  };
};

export default useRecsIdeas; 